import { ExportarExcelMassivoService } from './../../../core/services/exportarExcelMassivo.service';
import { Component, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { FilterConstants } from "src/app/constants/filterConstants";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TableConstants } from "src/app/constants/tableConstants";
import { CommonService } from "src/app/core/services/common.service";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { ListValueService } from "src/app/core/services/list-value.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { AdvancedFiltersService } from "src/app/core/services/advancedFilters.service";
import { CertificatesService } from "../../services/certificates.service";
import { Certificates } from "../../models/certificatesQuery";
import { FiltersComponent } from "src/app/shared/filters/filters.component";
import { TableComponent } from "src/app/shared/table/table.component";
import { ModalTableComponent } from "src/app/shared/modal-table/modal-table.component";
import {
  Options,
  OptionsOutTable,
} from "src/app/shared/filters/models/filters.model";
import { ScreenConstants } from "src/app/constants/screenId.constants";
import { TokenService } from 'src/app/core/services/token.service';
import { AppConstants } from 'src/app/constants/app.constants';

@Component({
  selector: "app-list-query",
  templateUrl: "./list-query.component.html",
  styleUrls: ["./list-query.component.sass"],
})
export class ListQueryComponent implements OnInit {
  @ViewChild("insideTable") filtersInsideTable: FiltersComponent;
  @ViewChild("outTable") filtersOutTable: FiltersComponent;
  @ViewChild("certificates") certificates: TableComponent;
  @ViewChild("certificatesHistory") certificatesHistory: TableComponent;
  @ViewChild("modal") modal: ModalTableComponent;
  certificatesList;
  certificatesHistoryList;
  previousCertsList;
  filtersTable: string;
  filtersTableHistory: string;
  filtersTableJSON;
  filtersTableJSONAux;
  filtersTableHistoryJSON;
  filtersTableHistoryJSONAux;
  filtersPrevCertsJSON;
  filtersSearch = "";
  filterList = FilterConstants.certificatesQuery;
  tableList = TableConstants.certificatesQuery;
  tableHistoryList = TableConstants.certificatesQueryHistory;
  tablePrevCertsList = TableConstants.previousCertsQuery;
  routingMailBox = RoutingConstants.certificatesQuery;
  routingHistory = RoutingConstants.certificatesQueryHistory;
  public optionsMailBox: Options =
    TableConstants.NotShowCreateDeleteAndArrowUpDown;
  public optionsMailBoxFilter: Options = {
    create: false,
    delete: false,
    arrowUpDown: false,
    orderColumns: true,
    label: false,
    filtersButton: true,
    downloadReport: false,
    editButtonEmpty: false,
    showCheckbox: false,
  };
  public optionsHistory: Options =
    TableConstants.NotShowCreateDeleteAndArrowUpDownFiltersButtonAndShowLabel;
  optionsPrevCerts =
    TableConstants.NotShowCreateDeleteAndArrowUpDownEditButtoAndShowLabel;
  filterListOutTable = FilterConstants.certificatesMailBoxOutTable;
  filtersSearchOutTable = "";
  public optionsFiltersOutTable: OptionsOutTable = {
    isOutTable: true,
    showFilters: false,
    style: { "min-width": "1400px" },
    showCheckbox: false,
  };
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;
  numPagesHistory: number = 0;
  numElementsHistory: number = 0;
  totalElementsHistory: number = 0;
  certificatesLoaded: boolean = false;
  certificatesHistoryLoaded: boolean = false;
  showTableFilter = false;
  showFiltersOut: boolean = false;
  showFilterButtons: boolean = false;
  warningShowed = {
    notHistory: false,
    history: false,
  };

  filterTramite = true;
  filterHistorico = true;

  mensajeAvisoExportar: boolean = false;
  roles = AppConstants.roles;
  userConcesionario: boolean = this.tokenService.hasRole(this.roles.CONCES);

  titleModal: string;

  constructor(
    private certificatesService: CertificatesService,
    private exportarExcelMassivoService: ExportarExcelMassivoService,
    private translateService: TranslateService,
    private toastrAlertService: ToastrAlertService,
    private filtersTableStateService: FiltersTableStateService,
    private commonService: CommonService,
    private listValueService: ListValueService,
    private sweetAlertService: SweetAlertService,
    private tokenService: TokenService,
    private advancedFiltersService: AdvancedFiltersService
  ) {
    this.optionsMailBox.style = { "min-width": "1400px" };
    this.optionsHistory.style = { "min-width": "1400px" };
    this.optionsMailBoxFilter.style = { "min-width": "1400px" };
    this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
      "peCreacion",
      ScreenConstants.certificates.queryCertificates
    );
    this.filtersTableHistoryJSON =
      this.filtersTableStateService.initFiltersTableHistory(
        "peCreacion",
        ScreenConstants.certificates.queryCertificatesHistory
      );
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.filtersTableHistory = this.filtersTableStateService.getString(
      this.filtersTableHistoryJSON
    );
    this.filtersSearch = this.filtersTableStateService.composeFiltersInTable(
      this.filterList
    );
    this.filtersSearchOutTable =
      this.filtersTableStateService.composeFiltersOutTable(
        this.filterListOutTable
      );
  }

  ngOnInit(): void {
    this.getList(this.filtersTable);
    this.getHistoryList(this.filtersTableHistory);
    this.getFiltersByUser();
    this.getAnalystList();
    this.getBrandsList();
    this.getEstadosList();
    this.getCertificateList();
    this.getTiposdeVehiculoList();
    this.getActivedTemplates();
    this.getReformsList();


  }

  getList(filtersTable: string) {
    let filters = this.commonService.concatThreeFilters(
      filtersTable,
      this.filtersSearch,
      this.filtersSearchOutTable
    );
    this.warningShowed.notHistory = false;
    this.sweetAlertService.sweetAlertLoading();
    this.certificatesService.getQueryListCertificates(filters).subscribe(
      (data) => {
        if (data) {
          this.certificatesList = data.content.map((e) =>
            Certificates.certificateFromJson(e)
          );
          this.numPages = data.totalPages == 0 ? 1 : data.totalPages;
          this.numElements = data.numberOfElements;
          this.totalElements = data.totalElements;
          this.certificatesLoaded = true;
          if (this.certificatesHistoryLoaded) {
            this.sweetAlertService.sweetAlertClose();
          }

          if (
            data.content &&
            data.content.length == 0 &&
            this.certificatesHistoryList &&
            this.certificatesHistoryList.length == 0
          ) {
            this.warningShowed.notHistory = true;
            this.toastrAlertService.showWarning(
              this.warningShowed.history,
              this.warningShowed.notHistory
            );
          }
        } else {
          this.certificatesList = [];
          this.certificatesLoaded = true;
          if (this.certificatesHistoryLoaded) {
            this.sweetAlertService.sweetAlertClose();
          }
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  getHistoryList(filtersTableHistory: string) {
    let filters = this.commonService.concatThreeFilters(
      filtersTableHistory,
      this.filtersSearch,
      this.filtersSearchOutTable
    );
    this.warningShowed.history = false;
    this.sweetAlertService.sweetAlertLoading();
    this.certificatesService.getQueryListHistoryCertificates(filters).subscribe(
      (data) => {
        if (data) {
          this.certificatesHistoryList = data.content.map((e) =>
            Certificates.certificateFromJson(e)
          );
          this.numPagesHistory = data.totalPages == 0 ? 1 : data.totalPages;
          this.numElementsHistory = data.numberOfElements;
          this.totalElementsHistory = data.totalElements;
          this.mensajeAvisoExportar = this.totalElementsHistory > 10000;
          this.certificatesHistoryLoaded = true;
          if (this.certificatesLoaded) {
            this.sweetAlertService.sweetAlertClose();
          }
          if (
            data.content &&
            data.content.length == 0 &&
            this.certificatesList &&
            this.certificatesList.length == 0
          ) {
            this.warningShowed.history = true;
            this.toastrAlertService.showWarning(
              this.warningShowed.history,
              this.warningShowed.notHistory
            );
          }
        } else {
          this.certificatesHistoryList = [];
          this.certificatesHistoryLoaded = true;
          if (this.certificatesLoaded) {
            this.sweetAlertService.sweetAlertClose();
          }
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  getCertificateList() {
    this.listValueService.listCertificates("1", "true").subscribe(
      (data) => {
        let pos = this.filterList.findIndex((e) => e.label == "Certificado");
        this.filterList[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getAnalystList() {
    this.listValueService.listaAnalistasBuzon().subscribe(
      (data) => {
        let pos = this.filterList.findIndex((e) => e.label == "Analista");
        data.sort(function (a, b) {
          if (a.usuarioId.toUpperCase() < b.usuarioId.toUpperCase()) {
            return -1;
          }
          if (a.usuarioId.toUpperCase() > b.usuarioId.toUpperCase()) {
            return 1;
          }
          return 0;
        });
        this.filterList[pos]["selectorConf"].dataList = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.analystNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getBrandsList() {
    this.listValueService.listValuesMarcas().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex((e) => e.label == "Marca");
        this.filterListOutTable[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getEstadosList() {
    this.listValueService.listEstadosByScreen("ES_CONS_CERT").subscribe(
      (data) => {
        let pos = this.filterList.findIndex((e) => e.label == "Estado");
        this.filterList[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getActivedTemplates() {
    this.listValueService.listaPlatillasActivas().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex(
          (e) => e.label == "Plantilla utilizada"
        );
        this.filterListOutTable[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getTiposdeVehiculoList() {
    this.listValueService.listTipoVehiculo().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex(
          (e) => e.label == "Tipo homologado"
        );
        this.filterListOutTable[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getReformsList() {
    this.listValueService.listReformsPadre().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex(
          (e) => e.label == "Reforma"
        );

        this.filterListOutTable[pos]["selectorConf"].dataList =
          this.sortReforma(data);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  sortReforma(data) {
    return data.sort(function (a, b) {
      var result;

      a = a.reId.split(".");
      b = b.reId.split(".");

      while (a.length) {
        result = a.shift() - (b.shift() || 0);

        if (result) {
          return result;
        }
      }

      return -b.length;
    });
  }

  filterTable(value: any) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTableStateService.setFiltersTable(this.filtersTableJSON);
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.getList(this.filtersTable);
  }

  filterTableHistory(value: any) {
    this.filtersTableHistoryJSON = value.filterTableJSON;
    this.filtersTableStateService.setFiltersTableHistory(
      this.filtersTableHistoryJSON
    );
    this.filtersTableHistory = this.filtersTableStateService.getString(
      this.filtersTableHistoryJSON
    );
    this.getHistoryList(this.filtersTableHistory);
  }

  filterPrevCerts(value: any) {
    this.filtersPrevCertsJSON = value.filterTableJSON;
    this.previousCertsList.sort((a, b) =>
      this.sortHCertsList(
        a,
        b,
        this.filtersPrevCertsJSON.order,
        this.filtersPrevCertsJSON.asc
      )
    );
    this.modal.dismiss();
  }

  buttonsHeader(item: string) {
    switch (item) {
      case "erase":
        this.filtersInsideTable.filtersSelectorSearch = [];
        this.filtersInsideTable.filtersValuesSearch = [];
        this.filtersOutTable.filtersSelectorSearch = [];
        this.filtersOutTable.filtersValuesSearch = [];
        this.filtersInsideTable.cleanSelectorAndDates();
        this.filtersOutTable.cleanSelectorAndDates();
        break;
      case "search":
        this.filtersSearch = this.filtersInsideTable.composeParams();
        this.filtersSearchOutTable = this.filtersOutTable.composeParams();
        this.filtersTableStateService.setFiltersTable(this.filtersTableJSON);
        this.filtersTableStateService.setPageState(0);
        this.filtersTableJSON =
          this.filtersTableStateService.getFiltersTableState();
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.getList(this.filtersTable);
        this.filtersTableStateService.setFiltersTableHistory(
          this.filtersTableHistoryJSON
        );
        this.filtersTableStateService.setPageStateHistory(0);
        this.filtersTableHistoryJSON =
          this.filtersTableStateService.getFiltersTableStateHistory();
        this.filtersTableHistory = this.filtersTableStateService.getString(
          this.filtersTableHistoryJSON
        );
        this.getHistoryList(this.filtersTableHistory);
        break;
      case "toggleFilters":
        if (this.showTableFilter) {
          this.showTableFilter = false;
          if (!this.showFiltersOut) {
            this.showFilterButtons = false;
          }
        } else {
          this.showTableFilter = true;
          this.showFilterButtons = true;
        }
        break;
    }
  }

  toggleFilterButtons(item: boolean) {
    this.showFiltersOut = item;
    if (this.showFiltersOut) {
      this.showFilterButtons = true;
    } else if (!this.showTableFilter) {
      this.showFilterButtons = false;
    }
  }

  getFiltersByUser() {
    this.advancedFiltersService
      .getAdvancedFiltersByUser("CERTIFICADO")
      .subscribe(
        (data) => {
          this.filterListOutTable =
            this.advancedFiltersService.renderFiltersOut(
              data,
              this.filterListOutTable
            );
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  previousHCertsList(id: string) {
    this.sweetAlertService.sweetAlertLoading();
    this.certificatesService.getQueryHistoryPreviousCertificates(id).subscribe(
      (data) => {
        if (data.hcertificados.length == 0) {
          this.sweetAlertService.sweetAlertClose();
        } else if (data.hcertificados.length == 1) {
          let dataDownload = {
            id: id,
            release: data.hcertificados[0].hcRelease,
            cve: data.hcertificados[0].hcCve,
          };
          this.downloadCert(dataDownload, true);
        } else if (data.hcertificados.length > 1) {
          this.filtersPrevCertsJSON = {
            asc: false,
            order: "hcFecha",
            page: 0,
            size: this.filtersTableStateService.getPersonalSize(),
          };

          this.previousCertsList = data.hcertificados;
          this.sweetAlertService.sweetAlertClose();
          this.titleModal = data.hcertificados[0].hcId;
          this.modal.open();
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  downloadCert(certData: any, isUnique: boolean) {
    let fileName = certData.id;
    if (!isUnique) {
      this.sweetAlertService.sweetAlertLoading();
    }
    console.log(certData);
    this.certificatesService
      .getPreviousFileCertificates(
        certData.id,
        certData.release,
        isUnique ? "true" : "false",
        certData.cve
      )
      .subscribe(
        (data) => {
          let blob = this.commonService.b64toBlob(
            data["fichero"],
            "application/pdf"
          );
          this.commonService.downloadFile(blob, fileName);
          this.sweetAlertService.sweetAlertClose();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  private sortHCertsList(a, b, order, asc) {
    if (order == "hcFecha") {
      let aFecha =
        a[order].split("/")[2] +
        "/" +
        a[order].split("/")[1] +
        "/" +
        a[order].split("/")[0];
      let bFecha =
        b[order].split("/")[2] +
        "/" +
        b[order].split("/")[1] +
        "/" +
        b[order].split("/")[0];

      if (asc) {
        return aFecha > bFecha ? 0 : -1;
      } else {
        return bFecha > aFecha ? 0 : -1;
      }
    } else {
      if (asc) {
        return a[order] > b[order] ? 0 : -1;
      } else {
        return b[order] > a[order] ? 0 : -1;
      }
    }
  }

  public showFilters(type: string) {
    if (type === "normal") {
      this.showTableFilter = true;
    }
    this.showFilterButtons = true;
  }

  public exportToExcel()
  {
    if(this.mensajeAvisoExportar)
    {
      this.toastrAlertService.toastrInfo("Solo se van a exportar los primeros 10.000 registros");
    }

    const filters = this.commonService.concatThreeFilters(
      this.filtersTable,
      this.filtersSearch,
      this.filtersSearchOutTable
    );

    const cleanFilters = filters.startsWith('?') ? filters.slice(1) : filters;

    const filtros: Record<string, any> = cleanFilters.split('&').reduce((acc, filter) => {
        const [key, value] = filter.split('=');
        acc[key] = decodeURIComponent(value); 
        return acc;
    }, {});

    filtros.page = 0;
    filtros.size = 10000;

    const historyFilters = this.filtersTableHistory.split('&').reduce((acc, filter) => {
        const [key, value] = filter.split('=');
        if (key === 'asc') {
            acc['ascHistory'] = decodeURIComponent(value);
        } else if (key === 'order') {
            acc['orderHistory'] = decodeURIComponent(value);
        }
        return acc;
    }, {});

    Object.assign(filtros, historyFilters);

    this.exportarExcelMassivoService.exportToExcel("certificado", filtros);
  }
}
